/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './weather-station-details.scss';

/* eslint-disable import/no-unresolved, import/default */

import weatherStationDetailsTemplate from './weather-station-details.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.client.weatherStationDetails', [])
    .directive('agWeatherStationDetails', WeatherStationDetails)
    .name;

/*@ngInject*/
function WeatherStationDetails() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: WeatherStationDetailsController,
        controllerAs: 'vm',
        templateUrl: weatherStationDetailsTemplate
    };
}

/*@ngInject*/
function WeatherStationDetailsController($scope, $log, $translate, unitService, agTypes, agUtils, types, weatherStationService, userService) {

    let vm = this;

    vm.agTypes = agTypes;
    vm.loading = false;

    vm.tempHistoryUnits = unitService.temperatureUnitSymbol();
    vm.humHistoryUnits = '%';

    vm.latestValuesSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: function(subscription) {
                vm.loading = subscription.loadingData;
            }
        },
        useDashboardTimewindow: false
    };

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN' || userService.getAuthority() === 'CUSTOMER_USER';
    vm.weatherStationId = null;
    vm.weatherStation = null;
    vm.weatherStationDevice = null;
    vm.helpPageAction = agUtils.createHelpActionConfig("agWeatherStation");

    vm.tempColor = tempColor;
    vm.humColor = humColor;
    
    vm.cropNames = []
    agUtils.getCropNames().then(
        (response) => {
            vm.cropNames = [];
            var cropNames = response.jsonValue;
            for (var property in cropNames) {
                var cropNameObj = {};
                cropNameObj.key = property;
                cropNameObj.value = cropNames[property];
                vm.cropNames.push(cropNameObj);
            }
            vm.cropNames.sort((a,b) => a.placement > b.placement)
        }
    );

    $scope.$watch('vm.ctx', function() {
        if (vm.ctx && vm.showData) {
            vm.ctx.widgetActions = [vm.helpPageAction];
            vm.ctx.hideTitlePanel = false;

            vm.weatherStationId = null;
            if (vm.ctx.stateController) {
                vm.weatherStationId = vm.ctx.stateController.getStateParams().entityId;
            }
            loadWeatherStation();
            $scope.$watch(function() {
                    return vm.ctx.stateController.getStateParams().entityId;
                },
                function (newWeatherStationId, prevWeatherStationId) {
                    if (newWeatherStationId && !angular.equals(newWeatherStationId, prevWeatherStationId)) {
                        vm.weatherStationId = newWeatherStationId;
                        loadWeatherStation();
                    }
                }
            );

        }
    });

    $scope.$watch(function() { return vm.weatherStation ? (vm.weatherStation.label || vm.weatherStation.name) : null; }, function(title) {
        if (vm.showData && vm.ctx && title) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('dashboardTimewindowChanged', function (event, newDashboardTimewindow) {
        if (vm.latestValuesSubscription) {
            var newTimewindowConfig = angular.copy(newDashboardTimewindow);
            newTimewindowConfig.aggregation.type = types.aggregation.none.value;
            newTimewindowConfig.aggregation.limit = 1;
            vm.latestValuesSubscription.timeWindowConfig = newTimewindowConfig;
        }
    });

    $scope.$on('$destroy', function() {
        reset();
    });

    function loadWeatherStation() {
        vm.weatherStation = null;
        vm.weatherStationDevice = null;
        reset();
        if (vm.weatherStationId) {
            vm.loading = true;
            weatherStationService.getWeatherStation(vm.weatherStationId).then(
                function success(weatherStation) {
                    vm.weatherStation = weatherStation;
                    weatherStationService.getWeatherStationDevices(vm.weatherStationId).then(
                        function success(weatherStationDevices) {
                            for (var i=0;i<weatherStationDevices.length;i++) {
                                if (weatherStationDevices[i].type == agTypes.deviceType.weatherStation) {
                                    vm.weatherStationDevice = weatherStationDevices[i];
                                    break;
                                }
                            }
                            if (vm.weatherStationDevice) {
                                var cropKeys = vm.cropNames.map(n => n.key)
                                var emcPrefix = vm.agTypes.telemetry.sensorLines.emcPrefix
                                var emcTs = cropKeys.map(k => {
                                    return {name: emcPrefix + k}
                                })
                                var latestValuesSubscriptionsInfo = [{
                                    type: types.datasourceType.entity,
                                    entityType: types.entityType.device,
                                    entityId: vm.weatherStationDevice.id.id,
                                    entityName: vm.weatherStationDevice.name,
                                    timeseries: [
                                        {name: vm.agTypes.telemetry.weatherStation.temperature},
                                        {name: vm.agTypes.telemetry.weatherStation.humidity}
                                    ].concat(emcTs)
                                }];
                                vm.latestValuesSubscriptionOptions.timeWindowConfig = angular.copy(vm.ctx.dashboardTimewindow);
                                vm.latestValuesSubscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
                                vm.latestValuesSubscriptionOptions.timeWindowConfig.aggregation.limit = 1;
                                vm.ctx.subscriptionApi.createSubscriptionFromInfo (
                                    types.widgetType.timeseries.value, latestValuesSubscriptionsInfo, vm.latestValuesSubscriptionOptions, false, true).then(
                                    function(subscription) {
                                        vm.latestValuesSubscription = subscription;
                                    }
                                );

                                vm.weatherStationTempHistorySubscriptionsInfo = [{
                                    type: types.datasourceType.entity,
                                    entityType: types.entityType.device,
                                    entityId: vm.weatherStationDevice.id.id,
                                    entityName: vm.weatherStationDevice.name,
                                    timeseries: [
                                        {
                                            name: agTypes.telemetry.weatherStation.temperature,
                                            label: $translate.instant('ag.weather-station.temperature'),
                                            color: agTypes.colors.maxColor,
                                            postFuncBody: unitService.temperaturePostprocessingFuncBody()
                                        }
                                    ]
                                }];

                                vm.weatherStationHumHistorySubscriptionsInfo = [{
                                    type: types.datasourceType.entity,
                                    entityType: types.entityType.device,
                                    entityId: vm.weatherStationDevice.id.id,
                                    entityName: vm.weatherStationDevice.name,
                                    timeseries: [
                                        {
                                            name: agTypes.telemetry.weatherStation.humidity,
                                            label: $translate.instant('ag.weather-station.humidity'),
                                            color: agTypes.colors.minColor
                                        }
                                    ]
                                }];
                                loadEMC()
                            } else {
                                vm.loading = false;
                            }
                        },
                        function fail() {
                            vm.loading = false;
                        }
                    );
                },
                function fail() {
                    vm.loading = false;
                }
            );
        }
    }

    function tempColor(/*val*/) {
        return agTypes.colors.normalGreyColor;
    }

    function humColor(/*val*/) {
        return agTypes.colors.normalGreyColor;
    }

    function reset() {
        if (vm.latestValuesSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.latestValuesSubscription.id);
        }
        resetValues();
    }

    function resetValues() {
        vm.tempVal = 0;
        vm.humVal = 0;
        vm.temp = '';
        vm.hum = '';
        vm.emc = {
            values: {}, selected: 'EMC-corn'
        }; 
    }
    $scope.selectedEMC = function () {
        return vm.emc.values[vm.emc.selected];
    }
    
    function loadEMC () {
        if (vm.weatherStationDevice) {
            vm.weatherStationEmcHistorySubscriptionsInfo = [{
                type: types.datasourceType.entity,
                entityType: types.entityType.device,
                entityId: vm.weatherStationDevice.id.id,
                entityName: vm.weatherStationDevice.name,
                timeseries: [{
                    name: vm.emc.selected
                }]
            }];
        }
    }

    $scope.$watch('vm.emc.selected', function() {
        loadEMC()
    })

    function onDataUpdated(subscription, apply) {
        var data = subscription.data;
        for (var i=0;i<data.length;i++) {
            var datasourceData = data[i];
            var val = getNumberValue(datasourceData);
            switch (datasourceData.dataKey.name) {
                case vm.agTypes.telemetry.weatherStation.temperature:
                    vm.tempVal = val;
                    vm.temp = vm.ctx.utils.formatValue(unitService.toUserTemperature(val), 1, '')+'°';
                    break;
                case vm.agTypes.telemetry.weatherStation.humidity:
                    vm.humVal = val;
                    vm.hum = vm.ctx.utils.formatValue(val, 1, '')+'%';
                    break;
            }
            if (datasourceData.dataKey.name.startsWith(agTypes.telemetry.sensorLines.emcPrefix)) {
                var name = datasourceData.dataKey.name
                var cropKey = name.split('-')[1]
                var crop = vm.cropNames.find(c => c.key == cropKey)
                var formattedValue = vm.ctx.utils.formatValue(val, 1, '') + '%';
                vm.emc.values[name] = {label: agTypes.cropNames[crop.value.name], value: formattedValue}
            }
        }
        if (apply) {
            $scope.$digest();
        }
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    function getNumberValue(keyData) {
        if (keyData && keyData.data && keyData.data[0] && angular.isDefined(keyData.data[0][1])) {
            if (!isNaN(keyData.data[0][1])) {
                return Number(keyData.data[0][1]);
            } else {
                return 0;
            }
        } else {
            return 0;
        }
    }
}